import { createRouter, createWebHistory } from 'vue-router';
import { headerOffset } from '@/utils/headerOffset';

import { landingRoutes } from '@/router/en/landingRoutes';
import { widgetRoutes, emptyWidgetRoutes } from '@/router/en/widgetRoutes';
import { publicPlanRoutes } from '@/router/en/publicPlanRouter';
import { termsAndConditionsRoutes } from '@/router/en/termsAndConditions';
import { privacyPolicyRoutes } from '@/router/en/privacyPolicy';
import { paymentRoutes } from '@/router/en/paymentRoutes';
import { forPersonalUsersRoutes } from '@/router/en/forPersonalUsers';
import { forCompaniesRoutes } from '@/router/en/forCompanies';
import { newsRoutes } from '@/router/en/news';
import { noveltyRoutes } from '@/router/en/novelty';
import { errorRoutes } from '@/router/en/errorRoutes';
import { pricingRoutes } from '@/router/en/pricing';
import { usersCasesRoutes } from '@/router/en/usersCases';

const routes = [...landingRoutes, ...widgetRoutes, ...emptyWidgetRoutes, ...publicPlanRoutes, ...termsAndConditionsRoutes, ...privacyPolicyRoutes, ...paymentRoutes, ...forPersonalUsersRoutes, ...forCompaniesRoutes, ...newsRoutes, ...noveltyRoutes, ...errorRoutes, ...pricingRoutes, ...usersCasesRoutes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (!to.hash) return { top: 0 };
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ el: to.hash, top: headerOffset(), behavior: 'smooth' });
      }, 0);
    });
  },
});

export { router, routes };
